import { cn } from "@/utils/theme";
import type { ButtonHTMLAttributes } from "react";

interface Props {
  active?: boolean;
  children: React.ReactNode;
}

const Tab = ({
  children,
  active,
  className,
  ...props
}: Props & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <div className={cn("h-11 rounded-t-lg bg-neutral-object inline-block")}>
      <button
        type="button"
        className={cn(
          "h-full cursor-pointer rounded-t-lg px-3 transition-colors relative border-x border-t border-transparent hover:bg-neutral-object-accent-silent",
          "font-semibold leading-3xl border-neutral-quiet",
          active ? "text-action" : "text-body-loud",
          active
            ? "bg-neutral-object-accent-silent border-neutral-quiet before:absolute before:-bottom-[1px] before:left-0 before:right-0 before:h-[1px] before:bg-neutral-object-accent-silent before:content-[''] before:z-10 after:absolute after:-bottom-[1px] after:left-0 after:right-0 after:h-[1px] after:bg-neutral-object after:content-[''] after:z-5"
            : "border-t-transparent border-x-transparent",
          className || "",
        )}
        {...props}
      >
        {children}
      </button>
    </div>
  );
};

export default Tab;
